export default __webpack_public_path__ + "static/media/psl.673fea20.cjs";